import Vue from 'vue'
import Vuex from 'vuex'

// 封装获取cooke的方法
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

Vue.use(Vuex)
export default new Vuex.Store({
    state: {},
    mutations: {
        teacher(state, detalist) {},
        token(state, detalist) {},
        myActivitys(state, detalist) {},
    },
    actions: {},
    modules: {}
})